import { Grid } from '@wrisk/ui-components'
import React from 'react'

import { Quote } from '../../../domain'
import { useConditionalCovers, useIncludedCovers } from '../../../hooks/covers'
import { getExposuresContentBaseUrl, useConfig } from '../../../state/configuration'
import { useProduct } from '../../product/productContext'
import { ConditionalCoverItem } from './ConditionalCoverItem'
import { IncludedCoverItem } from './IncludedCoverItem'

interface IncludedCoverItemsProps {
  quote: Quote
}

export const IncludedCoverItems: React.FC<IncludedCoverItemsProps> = ({ quote }) => {
  const { scheme, product } = useProduct()

  const includedCovers = useIncludedCovers(product)
  const conditionalCovers = useConditionalCovers(quote, product)

  const contentBaseUrl = useConfig(getExposuresContentBaseUrl(scheme.schemeCode))

  const includedCoverItems = includedCovers.map((cover) => (
    <IncludedCoverItem
      key={cover}
      width={1}
      cover={cover}
      contentBaseUrl={contentBaseUrl}
    />
  ))

  const conditionalCoverItems = conditionalCovers.map((cover) => (
    <ConditionalCoverItem key={cover.coverCode} width={1} conditionalCover={cover} />
  ))

  return (
    <Grid
      width={1}
      p={2}
      gridTemplateColumns={['1fr', '1fr', '1fr 1fr']}
      gridTemplateRows='auto'
      alignItems='stretch'
    >
      {includedCoverItems}
      {conditionalCoverItems}
    </Grid>
  )
}
